import ErrorPage from '@/components/ErrorPage';

export default function Error403() {
  return (
    <ErrorPage
      errorCode="403"
      title="This Dish is Reserved"
      message="Sorry, you don't have permission to access this exclusive area. This content is reserved for authorized users only."
      imagePath="/error-403.png"
      showRefresh={false}
    />
  );
}